import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';

import { Loader } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import './index.css';

import App from './App';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Winback from 'Modules/Winback/Winback';
import ErrorPage from 'error-page';
import ChatBot from 'Modules/Chatbot';
import Sales from 'Modules/Winback/routes/Sales/Sales';
import ProductsBought from 'Modules/Winback/routes/ProductsBought/ProducsBought';
import ProductsNotBought from 'Modules/Winback/routes/ProductsNotBought/ProductsNotBought';
import { Auth0Provider } from '@auth0/auth0-react';
import ProtectedRoute from 'ProtectedRoute';
import MapComponent from 'Modules/Map';

import defaultTheme from 'theme/theme';
import { MantineProvider } from '@mantine/core';
import "react-datepicker/dist/react-datepicker.css";
import NavigationMode from './Modules/NavigationMode';
import AccountTypeRouter from 'components/AccountTypeRouter';
import { GlobalProvider } from 'context/GlobalProvider';
//import LeadsApproval from 'Modules/LeadsApproval/LeadsApproval';

//import { createTheme, MantineProvider } from '@mantine/core';



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// dynamic import—this becomes its own chunk
const LeadsApproval = lazy(() =>
  import('Modules/LeadsApproval/LeadsApproval')
);

const SyncApproval = lazy(() =>
  import('Modules/SyncApproval/SyncApproval')
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <ProtectedRoute><AccountTypeRouter /></ProtectedRoute>,
      },
      {
        path: "chatbot",
        element: <ProtectedRoute><ChatBot /></ProtectedRoute>,
      },
      {
        path: "mapView",
        element: <ProtectedRoute>
          <MapComponent />

        </ProtectedRoute>
      },
      {
        path: "navigation-mode",
        element: (
          <ProtectedRoute>
            <NavigationMode />
          </ProtectedRoute>
        ),
      },
      {
        path: "leads-approval",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loader size="lg" />}>
              <LeadsApproval />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "sync-approval",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<Loader size="lg" />}>
              <SyncApproval />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "winback",
        element: <ProtectedRoute><Winback /></ProtectedRoute>,
        children: [
          {
            path: "",
            element: <Sales />
          },
          {
            path: "sales",
            element: <Sales />,
          },
          {
            path: "productsbought",
            element: <ProductsBought />,
          },
          {
            path: "productsnotbought",
            element: <ProductsNotBought />,
          }
        ]
      }
    ]
  }
]);

// Note if environment files are not set properly, then this will throw and error.  
if (!process.env.REACT_APP_AUTH0_DOMAIN || !process.env.REACT_APP_AUTH0_CLIENTID ||
  !process.env.REACT_APP_AUTH0_ISSUER || !process.env.REACT_APP_AUTH0_AUDIENCE) {
  throw new Error('Required Auth0 environment variables are not set');
}

const auth0_domain = process.env.REACT_APP_AUTH0_DOMAIN;
const auth0_clientID = process.env.REACT_APP_AUTH0_CLIENTID;
const auth0_issuer = process.env.REACT_APP_AUTH0_ISSUER;
const auth0_audience = process.env.REACT_APP_AUTH0_AUDIENCE;

root.render(
  <React.StrictMode>
    <MantineProvider theme={defaultTheme}>
      <Auth0Provider
        domain={auth0_domain}
        clientId={auth0_clientID}
        cacheLocation="localstorage"
        useRefreshTokens={true}
        authorizationParams={{
          redirect_uri: window.location.origin,
          issuer: auth0_issuer,
          audience: auth0_audience,
          scope: "openid profile email offline_access read:current_user read:current_user_metadata update:current_user_metadata"
        }}
      >
        <GlobalProvider>
          <RouterProvider router={router} />
        </GlobalProvider>
      </Auth0Provider>
    </MantineProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
